import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-nested-form-dialog',
  templateUrl: './nested-form-dialog.component.html',
  styleUrls: ['./nested-form-dialog.component.scss']
})
export class NestedFormDialogComponent {

  constructor(public dialogRef: MatDialogRef<NestedFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any){}

    returnResponse(res){
       return this.dialogRef.close(res);
    }
}
